module.exports = __webpack_public_path__ + "img/attention.2fac833d.png";